module.exports = __webpack_public_path__ + "img/add.737ec290.png";